import SvgIcon from "@mui/material/SvgIcon";

export const GiftIcon = (props) => (
  <SvgIcon {...props}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="22"
      fill="none"
      viewBox="0 0 24 24">
      <path
        stroke="#F2F2F2"
        strokeWidth="2"
        d="M20.625 2.941c0 .988-.233 1.71-.626 2.227-.008.011-.011.019-.019.026-.817 1.055-2.295 1.25-3.758 1.108-1.256-.12-2.5-.487-3.31-.767.134-.307.213-.689.213-1.097 0-.804-.304-1.489-.735-1.755 1.684-1.047 8.231-4.902 8.235.258z"></path>
      <path
        stroke="#F2F2F2"
        strokeWidth="2"
        d="M3.375 2.942c.011-5.15 6.559-1.299 8.235-.259-.431.266-.735.95-.735 1.755 0 .408.079.79.214 1.097-.81.28-2.055.647-3.311.767-1.467.142-2.948-.053-3.765-1.115-.398-.52-.642-1.246-.638-2.246z"></path>
      <path
        stroke="#F2F2F2"
        strokeWidth="2"
        d="M14.25 10.8h1.35l.026-.004c.135.752.188 1.62.124 2.623l1.125-1.123 1.5 1.497s.056-1.332-.244-2.994H22.5v11.974a.751.751 0 01-.75.749h-7.875V10.799h.375zM10.125 10.8v12.722H2.25a.751.751 0 01-.75-.749V10.8h4.369c-.3 1.662-.244 2.994-.244 2.994l1.5-1.497L8.25 13.42c-.064-1.003-.011-1.871.124-2.623l.026.003h1.725z"></path>
      <path
        stroke="#F2F2F2"
        strokeWidth="2"
        d="M10.125 10.8h3.75v12.722h-3.75V10.799z"></path>
      <path
        stroke="#F2F2F2"
        strokeWidth="2"
        d="M23.625 5.568v4.857a.376.376 0 01-.375.374h-5.119c-.259-1.478-.802-3.21-1.909-4.497 1.463.142 2.94-.053 3.758-1.108h3.27c.206 0 .375.168.375.374zM15.626 10.796l-.026.003h-1.35V7.623c.574.7 1.125 1.717 1.376 3.173z"></path>
      <path
        stroke="#F2F2F2"
        strokeWidth="2"
        d="M9.75 7.623v3.176H8.4l-.026-.003c.251-1.456.802-2.474 1.376-3.173zM4.013 5.187C4.83 6.249 6.31 6.444 7.777 6.302c-1.106 1.287-1.65 3.02-1.908 4.497H.75a.376.376 0 01-.375-.374V5.561c0-.206.169-.374.375-.374h3.263z"></path>
    </svg>
  </SvgIcon>
);
